import thukaramImg from "../../assets/images/testimonial/thukaram.png";
import prabhakarImg from "../../assets/images/testimonial/prabhakar.jpg";
import bhukariImg from "../../assets/images/testimonial/bhukari.jpg";
import sidhuImg from "../../assets/images/testimonial/siddhu.jpg";
import mohanImg from "../../assets/images/testimonial/mohan.png";
import sateeshImg from "../../assets/images/testimonial/sateesh.png";
import rajendraImg from "../../assets/images/testimonial/rajendra.png";

export const OFFICERS_PANEL = [
  {
    id: 1,
    name: "Dr. K Prabhakar Rao",
    designation:
      "Ex - Secretary Coastal Development Authority | Additional Commissioner Commercial Taxes | Economist",
    reviewHeading: "A Game Changer for UPSC Aspirants",
    reviewText:
      "IAS Jnani provides structured guidance and a well-planned approach to UPSC preparation. Highly recommended for serious aspirants. The Instructors have planned a strategic approach which I think will change the way the UPSC preparation is done",
    image: prabhakarImg,
  },
  {
    id: 5,
    name: "Dr. H Thukaram",
    designation: "Educationist | Secretary, KVS | Author",
    reviewHeading: "Revolutionizing UPSC Coaching",
    reviewText:
      "IAS Jnani is setting new benchmarks in UPSC preparation with its unique and structured approach. Their never-before-seen strategy empowers aspirants with the right knowledge, analytical skills, and confidence to crack the CSE exam efficiently.",
    image: thukaramImg,
  },
  {
    id: 4,
    name: "Mohan",
    designation: "Superintendent of Police | Excise",
    reviewHeading: "Guiding Light for UPSC Aspirants",
    reviewText:
      "Finding a reliable coaching institute is crucial for UPSC preparation, and IAS Jnani stands out with its comprehensive approach. Enhancing the way we prepare for exams is essential across all fields.",
    image: mohanImg,
  },
  {
    id: 2,
    name: "S A M Bukhari",
    designation:
      "Advisor | Senior Engineer - Karnataka Rural Infrastructure Development limited",
    reviewHeading: "Exceptional Content & Strategy",
    reviewText:
      "I appreciate the quality of study materials and mentorship at IAS Jnani. It helps aspirants think analytically and write better answers in UPSC mains. My wishes to all the aspirants and institute ",
    image: bhukariImg,
  },
  {
    id: 7,
    name: "H.N. Rajendra Prasad",
    designation: "Chief Executive | JSS Consultant",
    reviewHeading: "Right Guidance Shapes Aspirations",
    reviewText:
      "The UPSC journey demands more than just knowledge—it needs strategy, discipline, and the right mentorship. IAS Jnani offers all of this through its focused and student-friendly approach, making it a valuable guide for aspiring civil servants.",
    image: rajendraImg,
  },
  {
    id: 3,
    name: "R S Siddu",
    designation: "Senior National Athletic Coach",
    reviewHeading: "Comprehensive and Well-Structured",
    reviewText:
      "It's a dream for many to become a civil servant in India, and choosing the right coaching is the first big decision. IAS Jnani makes this journey easier with its well-structured approach. It's great to see so many students benefiting from it!",
    image: sidhuImg,
  },
  {
    id: 6,
    name: "Dr. Sateesh B",
    designation: "Advocate | Karnataka High Court | Educationist",
    reviewHeading: "Thorough and Well-Organized Training",
    reviewText:
      "Government exams are highly competitive, and many students dream of becoming IAS, IPS officers, or serving in other prestigious roles to contribute to the nation. IAS Jnani offers an excellent platform with top-quality teaching and dedication.",
    image: sateeshImg,
  },
];
